<template>

  <b-navbar toggleable="lg" type="dark" variant="dark">
    <img src="imgs/adds/logo.png" alt="Кузня Пальмира" class="main_page_logo">
  
    <router-link class="nav-link  mx-2 px-2 px-md-5 mx-md-5 text-uppercase app_title" to="/">{{$t('app_title')}}</router-link>

    

    <b-navbar-toggle target="nav_collapse" />

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto">
        <router-link class="mx-1 nav-link  px-xs-3" to="/">{{$t('main')}}</router-link>
        <router-link class="mx-1 nav-link  px-xs-3" to="/gallery">{{$t('gallery')}}</router-link>
        <router-link class="mx-1 nav-link  px-xs-3" to="/contact">{{$t('contact')}}</router-link>
        <locale-changer></locale-changer>
      </b-navbar-nav>

    </b-collapse>
  </b-navbar>

</template>



<script>

import LocaleChanger from "./LocaleChanger";

export default {
    components: {
      LocaleChanger,
    },
    computed: {
        lang: function () {
            return this.$i18n.t('lang');//this.$t('lang')
        }
    }
}
</script>

<style scoped lang="scss">
 .app_title {
    color: #fff;
    display: inline-block;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
 }
 .navbar {
    z-index: 100;
    .main_page_logo {
        opacity: 0.8;
        max-height: 40px;
    }

    .nav-center-img {
      height: 40px;
    }
 }
</style>
